import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  videosEnabled: PropTypes.bool,
};

const UploaderRecommendations = ({ className, videosEnabled = false }) => (
  <div
    className={classNames({
      'uploader-recommendations': true,
      [className]: !!className,
    })}
  >
    <p className="mb-1">
      Recommended file type: JPEG images {videosEnabled && 'and MP4 videos'}.
      Accepts JPEG, HEIC or PNG files.{' '}
      <span className="text-extra-bold">No RAW images.</span>
      <br />
      <span>
        Please make sure the color profile for your images is set to{' '}
        <span className="text-extra-bold">SRGB</span> prior to upload.
      </span>
    </p>
  </div>
);

UploaderRecommendations.propTypes = propTypes;

export default UploaderRecommendations;
